module.exports = {"TXTWCL_Returns":{"id":"TXTWCL_Returns","defaultMessage":"払戻"},"TXTWCL_n_a":{"id":"TXTWCL_n_a","defaultMessage":"なし"}}